export default {
  company_object: {},
  objects: [],
  notification: {},
  objectsMap: [],
  sourcesSocket: [],
  newChartValue: [],
  sourcesSocketBool: false,
  pollutionSources: [],
  pollutionSourceNormatives: [],
  pollutionSourceNormativesCurrent: [],
  pollutionSourcesSelectList: [],
  pollutionSourcesDiagrams: [],
  selectPollutionSourcesList: [],
  pollutionSourceNormativeCharts: {},
  countCompanyRegion: [],
  filters: {},
  firstEye: false,
  secondEye: false,
  setSelectList: {
    next: 0,
    data: [],
    count: 0
  }
}
